/**
 * Sum of Unicode char codes — deterministic, used for modulo indexing
 * (presence colors, guest personas).
 */
export function sumCharCodeHash(s: string): number {
	return s.split("").reduce((acc, ch) => acc + ch.charCodeAt(0), 0);
}
